/**
 * SAM-842: the guests of a pass created from the detail / payment step (AccessPage) carry what the guests step
 * captured, the same fields the direct-create path already sends: the scan's ID number, nationality, date of birth
 * and photo, for the main guest and for each companion (null when typed), and each companion's phone.
 */

export interface ScanFields {
  idnum?: string | null;
  nationality?: string | null;
  birthdate?: string | null;
  photo_url?: string | null;
}

export interface CompanionInput extends ScanFields {
  firstName?: string;
  lastName?: string;
  tel?: string;
}

/** The scan fields as the business_access POST takes them: null when the guest was typed. */
export const scanFields = (g: ScanFields | undefined) => ({
  idnum: g?.idnum || null,
  nationality: g?.nationality || null,
  birthdate: g?.birthdate || null,
  photo_url: g?.photo_url || null,
});

/**
 * `business_guests`: the companions captured on the guests step, or generic ones by count when the step left no
 * list (adults beyond the main guest).
 */
export const buildBusinessGuests = (adults: number, companions: CompanionInput[] = []) => {
  if (adults <= 1) return [];
  if (companions.length > 0) {
    return companions.map((c) => ({
      name: c.firstName || 'Companion',
      last_name: c.lastName || '',
      title_es: 'Acompañante',
      tel: c.tel || '',
      ...scanFields(c),
    }));
  }
  return Array.from({ length: adults - 1 }, (_, i) => ({ name: `Companion ${i + 1}`, last_name: '', title_es: 'Acompañante' }));
};
